/**
 * Related LabCorp result / trend observation codes.
 *
 * Mirrors one-labcorp-mobile ONL-4108 (`a7740b09`) so history and trends
 * treat a legacy code and its replacement as one analyte (PCSA-13486).
 */
export const LEGACY_TO_CANONICAL_RESULT_CODE: Record<string, string> = {
  '012059': '012065', // LDL Chol Calc (NIH)
  '011919': '011925', // VLDL Cholesterol Calc
  '011923': '011926', // LDL Calc Comment
};

export function canonicalResultCodeFor(code: string): string {
  return LEGACY_TO_CANONICAL_RESULT_CODE[code] ?? code;
}

/** True when both codes are the same analyte, including a cholesterol pair. */
export function resultCodesAreRelated(
  left?: string | null,
  right?: string | null
): boolean {
  if (!left || !right) {
    return false;
  }
  return canonicalResultCodeFor(left) === canonicalResultCodeFor(right);
}

/**
 * True when any FHIR `Observation.code.coding` entry belongs to the same
 * unified analyte as [resultCode].
 */
export function observationMatchesResultCode(
  coding: Array<{ code?: string } | undefined> | undefined,
  resultCode: string
): boolean {
  if (!coding?.length || !resultCode) {
    return false;
  }
  return coding.some((entry) => resultCodesAreRelated(entry?.code, resultCode));
}
